import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'


const FileManagerButton = withStyles({
    root: {
      size: "small",
      textTransform: 'none'
    }
})(Button)


const AppBarButton = withStyles({
  root: {
    size: "medium",
    textTransform: 'none'
  }
})(Button)



export {FileManagerButton, AppBarButton}